import { MutationTree } from 'vuex';
import { EntityState, LayoutItem } from '@/store/entity/types';
import { CrudOperation } from '@/types/CrudOperation';


const mutations: MutationTree<EntityState> = {
  loadLayouts(state, payload: LayoutItem) {
    const isLayoutExist = state.layouts.find((item) => item.entity === payload.entity);
    if (!isLayoutExist) {
      state.layouts.push(payload);
    }
  },
  setLayoutClass(state, payload: string) {
    state.layoutClass = payload;
  },
  setModalState(state, payload: boolean) {
    state.isModalVisible = payload;
  },
  setOperation(state, operation: CrudOperation) {
    state.prevOperation = state.operation;
    state.operation = operation;
  },
};

export default mutations;
